/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BasicSettingsDto } from '../model';
// @ts-ignore
import { PaymentsConfiguration } from '../model';
/**
 * SystemSettingsApiControllerApi - axios parameter creator
 * @export
 */
export const SystemSettingsApiControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasicSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/settings/basic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsConfiguration: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/settings/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BasicSettingsDto} basicSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBasicSettings: async (basicSettingsDto: BasicSettingsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'basicSettingsDto' is not null or undefined
            assertParamExists('saveBasicSettings', 'basicSettingsDto', basicSettingsDto)
            const localVarPath = `/api/admin/settings/basic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(basicSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaymentsConfiguration} paymentsConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentsConfiguration: async (paymentsConfiguration: PaymentsConfiguration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentsConfiguration' is not null or undefined
            assertParamExists('updatePaymentsConfiguration', 'paymentsConfiguration', paymentsConfiguration)
            const localVarPath = `/api/admin/settings/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentsConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemSettingsApiControllerApi - functional programming interface
 * @export
 */
export const SystemSettingsApiControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemSettingsApiControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBasicSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<BasicSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBasicSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentsConfiguration(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<PaymentsConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentsConfiguration(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BasicSettingsDto} basicSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBasicSettings(basicSettingsDto: BasicSettingsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBasicSettings(basicSettingsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PaymentsConfiguration} paymentsConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentsConfiguration(paymentsConfiguration: PaymentsConfiguration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaymentsConfiguration(paymentsConfiguration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemSettingsApiControllerApi - factory interface
 * @export
 */
export const SystemSettingsApiControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemSettingsApiControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasicSettings(options?: any): Promise<BasicSettingsDto> {
            return localVarFp.getBasicSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsConfiguration(options?: any): Promise<PaymentsConfiguration> {
            return localVarFp.getPaymentsConfiguration(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BasicSettingsDto} basicSettingsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBasicSettings(basicSettingsDto: BasicSettingsDto, options?: any): Promise<void> {
            return localVarFp.saveBasicSettings(basicSettingsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaymentsConfiguration} paymentsConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentsConfiguration(paymentsConfiguration: PaymentsConfiguration, options?: any): Promise<void> {
            return localVarFp.updatePaymentsConfiguration(paymentsConfiguration, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemSettingsApiControllerApi - object-oriented interface
 * @export
 * @class SystemSettingsApiControllerApi
 * @extends {BaseAPI}
 */
export class SystemSettingsApiControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemSettingsApiControllerApi
     */
    public getBasicSettings(options?: AxiosRequestConfig) {
        return SystemSettingsApiControllerApiFp(this.configuration).getBasicSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemSettingsApiControllerApi
     */
    public getPaymentsConfiguration(options?: AxiosRequestConfig) {
        return SystemSettingsApiControllerApiFp(this.configuration).getPaymentsConfiguration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BasicSettingsDto} basicSettingsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemSettingsApiControllerApi
     */
    public saveBasicSettings(basicSettingsDto: BasicSettingsDto, options?: AxiosRequestConfig) {
        return SystemSettingsApiControllerApiFp(this.configuration).saveBasicSettings(basicSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentsConfiguration} paymentsConfiguration 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemSettingsApiControllerApi
     */
    public updatePaymentsConfiguration(paymentsConfiguration: PaymentsConfiguration, options?: AxiosRequestConfig) {
        return SystemSettingsApiControllerApiFp(this.configuration).updatePaymentsConfiguration(paymentsConfiguration, options).then((request) => request(this.axios, this.basePath));
    }
}
